import { __awaiter } from "tslib";
import { Container, Service } from './container';
import { datadogLogs } from '@datadog/browser-logs';
const LOG_LEVELS = ['debug', 'info', 'warn', 'error'];
// An expected outcome on a merchant page (Wix visitor not signed in, account
// not connected, expired session, throttled); the API already records it.
const EXPECTED_HTTP_STATUSES = [401, 403, 404, 429];
export class Logger extends Service {
    constructor() {
        super(...arguments);
        this.contextName = '';
        this.initDatadogLibrary = () => {
            datadogLogs.init({
                clientToken: process.env.APP_DATADOG_CLIENT_TOKEN || '',
                site: 'datadoghq.com',
                forwardErrorsToLogs: false,
                sessionSampleRate: 100,
                env: process.env.APP_ENV,
                service: `twism-${process.env.APP_ENV}-widget`
            });
            // Logs below this level are dropped in the browser, before ingestion. The
            // SDK accepts any string here and an unknown one drops every log, errors
            // included.
            const level = process.env.APP_LOG_LEVEL;
            datadogLogs.logger.setLevel(LOG_LEVELS.includes(level) ? level : 'warn');
        };
    }
    clearUser() {
        datadogLogs.clearUser();
    }
    identifyCustomer(id) {
        datadogLogs.setUser({
            id: id
        });
    }
    info(message, data) {
        console.log(message, data);
        this.log('info', message, data);
    }
    warn(message, data) {
        console.warn(message, data);
        this.log('warn', message, data);
    }
    error(error) {
        var _a;
        console.error(error);
        const level = EXPECTED_HTTP_STATUSES.includes((_a = error.response) === null || _a === void 0 ? void 0 : _a.status)
            ? 'info'
            : 'error';
        if (!error.stack.startsWith('TypeError: Failed to fetch') &&
            !error.message.includes('code 503'))
            this.log(level, error.stack, error);
    }
    context(name) {
        const logger = new Logger(this.ctx);
        logger.contextName = name;
        return logger;
    }
    log(level, message, meta) {
        return __awaiter(this, void 0, void 0, function* () {
            datadogLogs.logger.log(message, Object.assign(Object.assign({ name: this.contextName }, meta), { status: level }), level);
        });
    }
}
Container.add(Logger);
